import React from "react";
import { BaseComponent } from "../../../../base/BaseComponent";
import "./AdvisoryCard.less";

export default class AdvisoryCard extends BaseComponent {
  render() {
    return (
      <div className="bca-card gx-mb-5">
        {this.antd.colmd12(
          <div className="text-col">
            <h1 className="heading-big">
              {this.lang.Customized} {this.lang.Blockchain}{" "}
              {this.lang.Development}
            </h1>
            <p>
              To get a custom blockchain solution, contact us to get the
              services of our blockchain team. Our team will provide you a
              reliable solution with the help of modern tools and technologies.
            </p>
          </div>
        )}

        <div className="image-col">
          <img src={"/assets/images/blockchain-c.svg"} />
        </div>
      </div>
    );
  }
}
